import React, { useEffect, useState } from "react";
import { Input } from "antd";
import { Controller } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { icons } from "../../utils/fa-icons-map";
interface Props {
  title: string;
  placeholder: string;
  onChange?: any;
  disabled?: boolean;
  data?: any;
  className?: string;
  rules?: any;
  setValue?: any;
  setError?: any;
  control?: any;
  name: string;
  pattern?: any;
  onBlur?: any;
  icon?: string;
}

const InputUnControlledComponent: React.FC<Props> = ({
  title,
  placeholder,
  onChange,
  disabled,
  data,
  className,
  setValue,
  setError,
  rules,
  control,
  name,
  pattern,
  onBlur,
  icon
}) => {

  const numericalToStringConvertor = (val: any) => {
    if (typeof val === "number") {
      return val.toString(); // Ensure it's a string
    }
    return val ?? ""; // Handle null or undefined by returning an empty string
  };

  const [inputValue, setInputValue] = useState(data ? numericalToStringConvertor(data) : "");

  useEffect(() => {
    setInputValue(numericalToStringConvertor(data));
  }, [data]);

  // Handle input change with regex validation and handle null case
  const handleChange = (e: any) => {
    
    let val = e.target.value;

    // Trim the value to prevent leading/trailing spaces
    val = val.trimStart();

    // Convert to uppercase if alwaysCapital rule is present
    if (rules?.alwaysCapital) {
      val = val.toUpperCase();
    }

    // Remove leading zeros for numeric values
    if (rules?.allowValues === "onlyDigital" || rules?.allowValues === "onlyNumeric") {
      if (val.startsWith("0")) {
        val = val.replace(/^0+/, "");
      }
    }

    setInputValue(val);

  };

  const handleTextBoxIcon = (icon: string) => {
    const fa = icons.get(icon);
    if (fa) {
      return <FontAwesomeIcon className="mr-1" style={{ opacity: 0.4 }} icon={fa} />;
    } else {
      return <></>;
    }
  };

  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required: rules?.mandatory === true ? `${title} is required` : false,
        max: {
          value: rules?.maxValue || null,
          message: `Max value Is ${rules?.maxValue}.`,
        },
        min: {
          value: rules?.minValue,
          message: `Min value Is ${rules?.minValue}.`,
        },
        minLength: {
          value: rules?.minSize,
          message: `Min length Is ${rules?.minSize}.`,
        },
        maxLength: {
          value: rules?.maxSize,
          message: `Max length Is ${rules?.maxSize}.`,
        },
      }}
      render={({ field, fieldState, formState }) => (
        <>
          <Input
            suffix={icon ? handleTextBoxIcon(icon) : null}
            title={title}
            placeholder={placeholder}
            disabled={disabled}
            className={className}
            {...field}
            value={inputValue}
            name={name}
            onChange={handleChange} // Updated onChange
            onBlur={(ev) => {
              field.onBlur();
              if (onBlur) {
                onBlur(ev.target.value.trimStart());
              }
              if(onChange) {
                onChange(ev.target.value.trimStart());
              }
            }}
            maxLength={title === "email" ? 50 : (Number(rules?.maxSize) ?? 1000)}
            minLength={rules?.minSize ? Number(rules?.minSize) : 0}
          />
          
          {fieldState.error?.message && (
            <div className="ant-form-item-explain-error custom-error-message">
              {fieldState.error?.message}
            </div>
          )}

        </>
      )}
    />
  );
};

export { InputUnControlledComponent as InputComponent };
